// Third-party
import React from 'react';

// Components
import { SecondaryButton } from '@/views/components/buttons';
import { ShareAllModal } from '@/views/components/modals';

// Constants and types
import Comparison from '@/types/comparison';
import SharedComparisonInfos from '@/types/shared-comparison-infos';
import Nullable from '@/types/nullable';
import { SHARED_CONTENT_TYPES } from '@/utils/constants';

// Utils
import { FormattedMessage, formatMessage } from '@/utils/i18n';
import { comparisonHasItems } from '@/utils/comparison';
import { flatten } from '@/utils/objects';
import notification from '@/utils/notification';
import { Button } from '@capintel/component-lib/button';

type Props = {
  disabled?: boolean;
  comparison: Comparison;
  type: SHARED_CONTENT_TYPES;
  onShareComparison: (infos: SharedComparisonInfos) => Promise<Nullable<string>>;
  onSaveChanges: () => Promise<boolean>;
  dark?: boolean;
};

type State = {
  showShareAllModal: boolean;
};

class ComparisonShareButton extends React.Component<Props, State> {
  readonly state: State = {
    showShareAllModal: false,
  };

  shareComparisonIsDisabled = () => {
    const { disabled, comparison } = this.props;

    if (disabled) {
      return true;
    }

    const hasSelectedFields = () => {
      if (!comparison.selectedCategories) {
        return true;
      }

      const fields = Object.values(flatten(comparison.selectedCategories));
      return fields.length > 0;
    };

    return !comparisonHasItems(comparison, true) || !hasSelectedFields();
  };

  openShareAllModal = () => {
    const { comparison } = this.props;

    if (comparison._id && comparison._id.startsWith('new-')) {
      return notification.error(formatMessage('Comparison.ShareWarning'));
    }

    return this.setState({ showShareAllModal: true });
  };

  closeShareAllModal = () => this.setState({ showShareAllModal: false });

  render() {
    const { type, comparison, onShareComparison, onSaveChanges, dark } = this.props;
    const { showShareAllModal } = this.state;
    return (
      <>
        {dark ? (
          <SecondaryButton dark={false} onClick={this.openShareAllModal} className="secondary-v2 share-comparison" disabled={this.shareComparisonIsDisabled()}>
            <FormattedMessage id="Comparison.ShareComparison" />
          </SecondaryButton>
        ) : (
          <Button variant="secondary" onClick={this.openShareAllModal} disabled={this.shareComparisonIsDisabled()}>
            <FormattedMessage id="Comparison.ShareComparison" />
          </Button>
        )}

        <ShareAllModal
          showModal={showShareAllModal}
          onCancel={this.closeShareAllModal}
          onConfirm={this.closeShareAllModal}
          type={type}
          onShareComparison={onShareComparison}
          comparisonIsDirty={comparison.isDirty}
          onSaveChanges={onSaveChanges}
        />
      </>
    );
  }
}

export default ComparisonShareButton;
